module.exports = __webpack_public_path__ + "assets/img/08e5efc0de9a0358669084629496dc5b.svg";